module.exports = __webpack_public_path__ + "img/416.a15a760c.png";